import { Box, Typography } from "@mui/material";
import RedirectBackButton from "components/RedirectBackButton";
import { FORM_ERROR } from "final-form";
import useGlobalContext from "hooks/globalData";
import useTitle from "hooks/useTitle";
import useTrashablePromises from "hooks/useTrashablePromises";
import { FormattedMessage as T, useIntl } from "react-intl";
import { useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import {
  IWizardSaveRequest,
  SaveResponse,
  WizardSaveRequest,
} from "services/KnowfullyAdminClient";
import translateError from "utils/translateError";
import WizardForm from "./WizardForm";

const WizardCreateForm = () => {
  const { registerPromise } = useTrashablePromises();
  const { formatMessage: t } = useIntl();
  const { wizardService, wizardDetailsUrl, wizardsUrl } = useGlobalContext();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  useTitle(t({ id: "wizardFormCreateTitle" }));

  const onCancel = () => {
    navigate(wizardsUrl());
  };

  const onSubmit = async (values: IWizardSaveRequest) => {
    try {
      const createdWizard: SaveResponse = await registerPromise(
        wizardService.saveWizard(new WizardSaveRequest(values))
      );

      queryClient.invalidateQueries("wizards");
      navigate(wizardDetailsUrl(createdWizard.id));

      return createdWizard;
    } catch (err: any) {
      console.log(err);
      return { [FORM_ERROR]: translateError(err, t) };
    }
  };

  return (
    <>
      <Box my={2}>
        <RedirectBackButton
          redirectRoute={wizardsUrl()}
          labelKey="backToListButtonLabel"
        />
      </Box>
      <Typography variant="h5">
        <T id="wizardFormCreateTitle" />
      </Typography>
      <WizardForm
        onSubmit={onSubmit}
        submitLabel={t({ id: "wizardFormCreateButton" })}
        onCancel={onCancel}
      />
    </>
  );
};

export default WizardCreateForm;
